import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Employee } from 'src/app/models/Employees';
import { Relative } from 'src/app/models/Relative';
import { UtilityService } from 'src/app/util/utility.service';

import { User } from 'src/app/models/Users';
import { AuthService } from '../auth.service';
import { ParamService } from '../param.service';
import { BackEndService } from '../backEnd.service';
import { AlertService } from 'src/app/util/alert.service';
import { EmployeeSService } from './employeeS.service';
import { LoaderService } from 'src/app/util/loader.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityTs } from 'src/app/util/utilityTs';
import { InviteService } from './invite.service';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AlertController } from '@ionic/angular';
import { SwimService } from 'src/app/pages/vansh/vansh2/swim.service';
import { TranslateService } from '../translate.service';

@Injectable({
  providedIn: 'root',
})
export class RelativeService {

  relative: Relative = new Relative;
  relativeList: Relative[] = [];
  utilityService: UtilityService = new UtilityService();

  constructor(private backEnd: BackEndService, private auth: AuthService, private loader: LoaderService, private alertController: AlertController,
    public paramService: ParamService, private alert: AlertService, private empService: EmployeeSService, private swim: SwimService,
    private toastService: ToastService, private inviteService: InviteService, private location: Location, private trans: TranslateService) {
  }

  getRelative(id, variable?: string, localSave?: boolean) {
    variable = variable ?? "id";
    return new Promise<Relative[]>((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.Relative, [[variable, id]]).then((relativeList: Relative[]) => {
        if (localSave) {
          this.relativeList = relativeList;
          resolve(this.relativeList);
        } else {
          resolve(relativeList);
        }
      })
    })
  }


  saveObject(relative: Relative, saveInService?: boolean) {
    relative = relative ?? this.relative;
    return new Promise((resolve) => {
      if (!relative.created_by) {
        relative.created_by = this.auth.loggedInEmployee.user.id;
      }
      let existingRelation = this.relativeList.find(x => x.emp_id == relative.emp_id);
      if (existingRelation && existingRelation.relative_id == relative.relative_id) {
        console.log("Object already exists", relative, existingRelation);
        resolve(true);
      }
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.Relative, relative).then((response) => {
        if (response && saveInService) {
          let found = this.relativeList.find(x => x.id == relative.id);
          if (!found) {
            this.relativeList.unshift(this.relative);
          }
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }
  saveObjectList(relativeList: Relative[]) {
    return new Promise((resolve) => {
      relativeList.forEach(relative => {
        relative.created_by = relative.created_by ?? this.auth.loggedInEmployee.user.id;
        relative.business_id = relative.business_id ?? this.auth.business.id;
      });
      this.backEnd.updateList(appConfig.STORAGE_TABLE.Relative, relativeList).then((response) => {
        resolve(response);
      });
    });
  }
  deleteObjectList(list) {
    return new Promise((resolve) => {
      this.backEnd.deleteList(appConfig.STORAGE_TABLE.Relative, list).then((response) => {
        resolve(response);
      });
    });
  }

  // connectedRelativeMap = {
  //   "Brother": [{ "Father": "Father" }, { "Mother": "Mother" }, { "Sister": "Sister" }, { "Brother": "Brother" }],
  //   "Sister": [{ "Father": "Father" }, { "Mother": "Mother" }, { "Sister": "Sister" }, { "Brother": "Brother" }],
  //   "Father": [{ "Brother": "Son" }, { "Sister": "Daughter" }, { "Mother": "Wife" }],
  //   "Mother": [{ "Brother": "Son" }, { "Sister": "Daughter" }, { "Father": "Husband" }],
  //   "Daughter": [{ "Wife": "Mother" }, { "Husband": "Father" }, { "Son": "Brother" }, { "Daughter": "Sister" }],
  //   "Son": [{ "Wife": "Mother" }, { "Husband": "Father" }, { "Son": "Brother" }, { "Daughter": "Sister" }],
  //   "Wife": [{ "Daughter": "Daughter" }, { "Son": "Son" }],
  //   "Husband": [{ "Daughter": "Daughter" }, { "Son": "Son" }]
  // }
  connectedRelativeMap = {
    "Brother": [{ "Father": "Son" }, { "Mother": "Son" }, { "Sister": "Brother" }, { "Brother": "Brother" }],
    "Sister": [{ "Father": "Daughter" }, { "Mother": "Daughter" }, { "Sister": "Sister" }, { "Brother": "Sister" }],
    "Father": [{ "Brother": "Father" }, { "Sister": "Father" }, { "Mother": "Husband" }],
    "Mother": [{ "Brother": "Mother" }, { "Sister": "Mother" }, { "Father": "Wife" }],
    "Daughter": [{ "Wife": "Daughter" }, { "Husband": "Daughter" }, { "Son": "Sister" }, { "Daughter": "Sister" }],
    "Son": [{ "Wife": "Son" }, { "Husband": "Son" }, { "Son": "Brother" }, { "Daughter": "Brother" }],
    "Wife": [{ "Daughter": "Mother" }, { "Son": "Mother" }],
    "Husband": [{ "Daughter": "Father" }, { "Son": "Father" }]
  }


  async setRelative(selectedMember: Employee, newMember: Employee, relation: string) {
    let males = ['Brother', 'Father', 'Son', 'Husband'];

    const selectedMemberRelatives = await this.getRelative(selectedMember.id, "emp_id");
    const newMemberRelatives = await this.getRelative(newMember.id, "emp_id");
    this.relativeList = [];
    for (let connectedRelation of this.connectedRelativeMap[relation]) {
      let key = Object.keys(connectedRelation)[0];
      if (!environment.production) {
        console.log(key, connectedRelation[key]);
      }
      const relativeList = selectedMemberRelatives.filter(x => x.relation == key);
      for (let relative of relativeList) {
        const relativeEmp = this.createEmpFromRelative(relative, males.includes(relative.relation) ? 'MALE' : 'FEMALE');
        await this.createRelative(relativeEmp, newMember, connectedRelation[key]);
      }
    }

    const oppRelation = this.findOppRelation(relation, selectedMember.user.gender);
    for (let connectedRelation of this.connectedRelativeMap[oppRelation]) {
      let key = Object.keys(connectedRelation)[0];
      const relativeList = newMemberRelatives.filter(x => x.relation == key);
      for (let relative of relativeList) {
        const relativeEmp = this.createEmpFromRelative(relative, males.includes(relative.relation) ? 'MALE' : 'FEMALE');
        await this.createRelative(relativeEmp, selectedMember, connectedRelation[key]);
      }
    }

    await this.createRelative(selectedMember, newMember, relation);
  }

  private createEmpFromRelative(relative: Relative, selectedGender) {
    const relativeEmp = new Employee();
    relativeEmp.user = new User();

    relativeEmp.id = relative.relative_id;
    relativeEmp.user.gender = selectedGender;
    relativeEmp.user.dob = relative.dob;
    relativeEmp.user.url = relative.url;
    relativeEmp.user.name = relative.name;
    if (!environment.production) {
      console.log("Selected Emp", relativeEmp);
    }
    return relativeEmp;
  }

  private async createRelative(selectedMember: Employee, newMember: Employee, relation: string) {
    let newRelative = new Relative();
    let newRelativeList: Relative[] = await this.searchRelative([["emp_id", selectedMember.id], ["relative_id", newMember.id]]);
    if (newRelativeList.length > 0) {
      newRelative = newRelativeList[0];
      newRelative.existing = true;
    }
    newRelative.business_id = this.auth.business.id;

    newRelative.gender = selectedMember.user.gender;
    newRelative.emp_id = selectedMember.id;

    newRelative.relation = relation;

    newRelative.relative_id = newMember.id;
    newRelative.name = newMember.user.name;
    newRelative.url = newMember.user.url;
    newRelative.dob = newMember.user.dob;
    newRelative.death = newMember.user.user_pd.death_date;
    if (!environment.production) {
      console.log("NewRelative", newRelative);
    }
    this.relativeList.push(newRelative);
    // await this.saveObject(newRelative);
    await this.setOppRelationship(selectedMember, newMember, relation);
  }
  private async setOppRelationship(selectedMember: Employee, newMember: Employee, relation: string) {
    let oppRelative: Relative = new Relative();
    let newRelativeList: Relative[] = await this.searchRelative([["emp_id", newMember.id], ["relative_id", selectedMember.id]]);
    if (newRelativeList.length > 0) {
      oppRelative = newRelativeList[0];
      oppRelative.existing = true;
    }
    oppRelative.business_id = this.auth.business.id;

    oppRelative.gender = newMember.user.gender;
    oppRelative.emp_id = newMember.id;

    oppRelative.relation = this.findOppRelation(relation, selectedMember.user.gender);

    oppRelative.relative_id = selectedMember.id;
    oppRelative.name = selectedMember.user.name;
    oppRelative.url = selectedMember.user.url;
    oppRelative.dob = selectedMember.user.dob;
    oppRelative.death = selectedMember.user.user_pd.death_date;
    if (!environment.production) {
      console.log("OppRelative", oppRelative);
    }
    this.relativeList.push(oppRelative);
    // await this.saveObject(oppRelative);
  }

  private findOppRelation(relation: string, gender) {
    if (relation == appConfig.Relation.Brother || relation == appConfig.Relation.Sister) {
      if (gender == this.utilityService.genderList[0]) {
        return appConfig.Relation.Brother;
      } else {
        return appConfig.Relation.Sister;
      }
    }
    if (relation == appConfig.Relation.Daughter || relation == appConfig.Relation.Son) {
      if (gender == this.utilityService.genderList[0]) {
        return appConfig.Relation.Father;
      } else {
        return appConfig.Relation.Mother;
      }
    } if (relation == appConfig.Relation.Wife || relation == appConfig.Relation.Husband) {
      if (gender == this.utilityService.genderList[0]) {
        return appConfig.Relation.Husband;
      } else {
        return appConfig.Relation.Wife;
      }
    } if (relation == appConfig.Relation.Mother || relation == appConfig.Relation.Father) {
      if (gender == this.utilityService.genderList[0]) {
        return appConfig.Relation.Son;
      } else {
        return appConfig.Relation.Daughter;
      }
    }
  }

  async deleteEmpRelative(empId) {

    const response = await this.backEnd.deleteObject(appConfig.STORAGE_TABLE.Relative, empId, "relative_id")
    const response2 = await this.backEnd.deleteObject(appConfig.STORAGE_TABLE.Relative, empId, "emp_id")
    if (!response || !response2) {
      return false;
    } else {
      return true;
    }
  }

  deleteRelative(relativeId) {
    return new Promise((resolve) => {
      this.backEnd.deleteObject(appConfig.STORAGE_TABLE.Relative, relativeId).then((response) => {
        resolve(response);
      })
    })
  }
  updateRelativeInfo(employee) {
    this.getRelative(employee.id, "emp_id").then((relatives) => {
      for (let relative of relatives) {
        relative.gender = employee.user.gender;
      }
      this.saveObjectList(relatives);
    })
    this.getRelative(employee.id, "relative_id").then((relatives) => {
      for (let relative of relatives) {
        relative.name = employee.user.name;
        relative.url = employee.user.url;
        relative.dob = employee.user.dob;
        relative.death = employee.user.user_pd.death_date;
      }
      this.saveObjectList(relatives);
    })
  }


  searchRelative(query): Promise<Relative[]> {
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.Relative, query).then((response) => {
        resolve(response);
      })
    })
  }



  public async save(relativeEmployee, selectedEmployee, relation) {
    // if (this.empService.empValidation(relativeEmployee)) {

    this.loader.show("Checking and Saving...");
    let isPhoneValid = await this.checkExistingPhone(relativeEmployee, selectedEmployee, relation, relativeEmployee.user.user_pd.mobile);
    console.log("isPhoneValid: " + isPhoneValid);
    if (isPhoneValid) {
      let valid = await this.toastService.validation(relativeEmployee);
      if (valid) {
        let valid2 = this.localValidation(relativeEmployee);
        if (valid2) {
          this.loader.hideForce();
          relativeEmployee.user.name = UtilityTs.capitalizeFirstLetter(relativeEmployee.user.name);

          await this.setRelative(selectedEmployee, relativeEmployee, relation.relation);
          this.checkDuplicateRelative().then((success) => {
            if (success) {
              this.confirmRelativeCreate(relativeEmployee, selectedEmployee, relation);
            }
          })
        } else {
          this.loader.hideForce();
        }
      } else {
        this.loader.hideForce();
      }
    } else {
      this.loader.hideForce();
    }
  }

  localValidation(relativeEmp: Employee) {
    if (!relativeEmp?.user?.name) {
      this.toastService.warning(this.trans.translate("Please enter your name to proceed"));
      return false;
    }
    if (!relativeEmp?.user?.dob) {
      this.toastService.warning(this.trans.translate("Please select your date of birth to proceed"));
      return false;
    }
    if (!relativeEmp?.user?.gender) {
      this.toastService.warning(this.trans.translate("Please select your gender to proceed"));
      return false;
    }
    if (!relativeEmp?.user?.user_pd?.marital) {
      this.toastService.warning(this.trans.translate("Please select your marital status to proceed"));
      return false;
    }
    if (!relativeEmp?.user?.user_pd?.sub_community) {
      this.toastService.warning(this.trans.translate("Please select your gotra to proceed"));
      return false;
    }
    if (!relativeEmp?.user?.user_pd?.pincode) {
      this.toastService.warning(this.trans.translate("Please enter your area/pincode to proceed"));
      return false;
    }
    if (!relativeEmp?.user?.user_pd?.origin_city) {
      this.toastService.warning(this.trans.translate("Please enter your place of origin to proceed"));
      return false;
    }
    return true;
  }
  // }


  async checkDuplicateRelative(): Promise<boolean> {
    const duplicateRelatives: any[] = [];

    await Promise.all(
      this.relativeList.map(async (relative) => {
        const duplicateList: Relative[] = await this.searchRelative([['emp_id', relative.emp_id], ['relative_id', relative.relative_id]]);
        if (duplicateList.length > 0) {
          duplicateRelatives.push(relative);
        }
      })
    );

    if (duplicateRelatives.length > 0) {
      const msg = duplicateRelatives
        .map(r => r.name + " as " + r.relation + " <br>")
        .join('\n');
      this.alert.showAlert(this.trans.translate('Duplicate relation found:'), msg);
      return false;
    }
    return true;
  }



  confirmRelativeCreate(relativeEmployee, selectedEmployee, relation) {
    console.log("confirmRelativeCreate()", this.relativeList);
    let description = relativeEmployee.user.name + "'s Relative <ul>";
    for (let rel of this.relativeList) {
      if (rel.emp_id == relativeEmployee.id) {
        description += "<li><b>" + rel.relation + "</b> " + rel.name + " Ji</li>"
      }
    }
    description += "</ul>";
    description += selectedEmployee.user.name + "'s Relative <ul>";
    for (let rel of this.relativeList) {
      if (rel.emp_id == selectedEmployee.id) {
        description += "<li><b>" + rel.relation + "</b> " + rel.name + " Ji</li>"
      }
    }
    description += "</ul>";

    let button1 = "";
    let button2 = "Create";
    const userPd = relativeEmployee?.user?.user_pd;
    const user = relativeEmployee?.user;

    const hasMobile = !!userPd?.mobile;
    const isAlive = !userPd?.death_date;
    const age = user?.dob ? UtilityTs.getAge(new Date(user.dob)) : null;


    if (hasMobile) {
      button2 = this.trans.translate("Create Without Invite");
      button1 = this.trans.translate("Create and Invite");
    } else if (age !== null && age >= 18 && age <= 75 && isAlive) {
      button2 = this.trans.translate("Create Without Invite");
      button1 = this.trans.translate("Create and Invite");
    }


    this.alert.show3ButtonAlert(this.trans.translate("This will create following relationships."), description, button1, button2, "Cancel").then((value) => {
      if (value != 3) {
        this.empService.saveUser(appConfig.STORAGE_TABLE.USER, relativeEmployee.user).then(() => {
          relativeEmployee.user.user_pd.business_id = relativeEmployee.business_id;
          this.empService.saveUser(appConfig.STORAGE_TABLE.UserPd, relativeEmployee.user.user_pd).then(() => {
            relativeEmployee.type = "Family";
            this.empService.saveObject(relativeEmployee, false).then(() => {
              this.saveObjectList(this.relativeList).then(() => {
                this.paramService.setData(appConfig.STORAGE_TABLE.EMPLOYEE, relativeEmployee);
                this.toastService.success(this.trans.translate("Relative created successfully"));
                this.loader.hideForce();
                this.location.back();
                if (value == 1) {
                  if (hasMobile) {
                    relativeEmployee.creator = this.auth.loggedInEmployee;
                    this.inviteService.createInvite(null, relativeEmployee, relation.relation, selectedEmployee);
                  } else if (age !== null && age >= 18 && age <= 75 && isAlive) {
                    relativeEmployee.creator = this.auth.loggedInEmployee;
                    this.inviteService.createInvite(null, relativeEmployee, relation.relation, selectedEmployee);
                  } else {
                    console.log("Do not send");
                  }
                }
              });
            });
          });
        });
      } else {
        this.loader.hideForce();
      }
    })
  }

  public async checkExistingPhone(relativeEmployee, selectedEmployee, relation, mobile) {
    if (!relativeEmployee.user.user_pd.mobile || relativeEmployee.user.user_pd.mobile.trim().length == 0) {
      relativeEmployee.user.user_pd.mobile = null;
    }
    if (relativeEmployee.user.user_pd.mobile == null) {
      return true;
    }
    let emp: Employee = await this.empService.getEmpByVariable("user.user_pd.mobile", relativeEmployee.user.user_pd.mobile)
    if (emp) {
      if (emp.id == selectedEmployee.id) {
        this.alert.showAlert(this.trans.translate('Please Change Mobile Number'), this.trans.translate("This Mobile No. is already used for ") + selectedEmployee.user.name);
        return false;
      }
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.Relative, [["emp_id", selectedEmployee.id]]).then((relativeList: Relative[]) => {
        for (let relative of relativeList) {
          if (relative.id == emp.id) {
            this.alert.showAlert(this.trans.translate('Please Change Mobile Number'), this.trans.translate("This Mobile No. belongs to ") + relative.relation + " " + relative.name);
            return false;
          }
        }
      })
      await this.alert.showAlert(emp.user.name, "Phone number already exists. Do you want to add them as " + relation.relation + "?", 'Yes', 'No')
      relativeEmployee = emp;
      await this.setRelative(selectedEmployee, emp, relation.relation);
      let success = await this.checkDuplicateRelative();
      console.log("success: " + success);
      if (success) {
        this.confirmRelativeCreate(relativeEmployee, selectedEmployee, relation);
      }
      return false;
    } else {
      return true;
    }
  }

  showExistingRelations(id, name, callback) {
    this.backEnd.searchObject(appConfig.STORAGE_TABLE.Relative, [["emp_id", id]]).then((relativeList: Relative[]) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.Relative, [["relative_id", id]]).then((relativeList2: Relative[]) => {
        let inputList = [];
        for (let rel2 of relativeList) {
          let found = relativeList2.find(x => x.emp_id == rel2.relative_id);
          if (found) {
            let value = found.id + "," + rel2.id + ":" + rel2.relation;
            inputList.push({
              name: value,
              type: 'checkbox',
              label: found.relation + " of " + rel2.name + " Ji (" + rel2.relation + ")",
              value: value,
              checked: false,
            });
          } else {
            inputList.push({
              name: rel2.id,
              type: 'checkbox',
              label: "Extra Relation of " + rel2.relation + " " + rel2.name + " Ji",
              value: rel2.id,
              checked: false,
            });
          }
        }
        this.showDeleteRelationAlert(inputList, name, id, callback);
      })
    })
  }

  async showDeleteRelationAlert(inputList, name, id, callback) {
    const alert = await this.alertController.create({
      header: this.trans.translate('Current Relations of ') + name,
      message: this.trans.translate('Select and delete the relations if you think it is wrong'),
      inputs: inputList,
      buttons: [
        {
          text: this.trans.translate('Cancel'),
          role: 'cancel',
        },
        {
          text: this.trans.translate('Delete'),
          handler: async (data: string[]) => {
            if (data.length > 0) {
              let deleteIdList = [];
              for (let id2 of data) {
                let idList = id2.split(":");
                for (let id of idList[0].split(",")) {
                  deleteIdList.push({ "id": id });
                }
                console.log(idList[1], idList[0].split(","));
                if (idList[1] == 'Wife' || idList[1] == 'Husband') {
                  let node = this.swim.nodes.find(x => x.id == id);
                  console.log(node);
                  if (node) {
                    node.data.spouse = null;
                    node.data.spouse_url = null;
                  }
                }
              }
              console.log(deleteIdList);
              let response = await this.backEnd.deleteList(appConfig.STORAGE_TABLE.Relative, deleteIdList);
              console.log(response);
              console.log(this.swim.links);
              this.swim.links = this.swim.links.filter(
                x => !deleteIdList.find(y => y.id === (x as any).relativeId)
              );
              console.log(this.swim.links);

              this.toastService.success(this.trans.translate('Relations deleted'));
              callback("Working");
            } else {
              this.toastService.error(this.trans.translate('Select at least one relation to delete'));
              this.showExistingRelations(id, name, callback);
            }
            console.log('Selected:', data);
          },
        },
      ],
    });

    await alert.present();
  }

  async finalMerge(merge_nonEditable, merge_editable) {
    await this.updateRelativeId(merge_nonEditable, merge_editable)
    await this.empService.deleteEmployee(merge_nonEditable)
    this.toastService.success(this.trans.translate('Merged Successfully'));

  }
  async updateRelativeId(merge_nonEditable, merge_editable) {
    let neRelativeList = await this.getRelative(merge_nonEditable.id, "emp_id");
    let eRelativeList = await this.getRelative(merge_editable.id, "emp_id")
    let toDeleteRelative = neRelativeList.filter(x => eRelativeList.find(y => x.relative_id == y.relative_id));
    let toUpdateRelative = neRelativeList.filter(x => !eRelativeList.find(y => x.relative_id == y.relative_id));
    console.log(toDeleteRelative, toUpdateRelative);
    toUpdateRelative.forEach(relative => {
      relative.emp_id = merge_editable.id;
    })
    await this.saveObjectList(toUpdateRelative);
    await this.deleteObjectList(toDeleteRelative);
    let neRelativeList2 = await this.getRelative(merge_nonEditable.id, "relative_id");
    let eRelativeList2 = await this.getRelative(merge_editable.id, "relative_id")
    let toDeleteRelative2 = neRelativeList2.filter(x => eRelativeList2.find(y => x.emp_id == y.emp_id));
    let toUpdateRelative2 = neRelativeList2.filter(x => !eRelativeList2.find(y => x.emp_id == y.emp_id));
    console.log(toDeleteRelative2, toUpdateRelative2);
    toUpdateRelative2.forEach(relative => {
      relative.relative_id = merge_editable.id;
    })
    await this.saveObjectList(toUpdateRelative2);
    await this.deleteObjectList(toDeleteRelative2);
  }
}
